import React from 'react';

/**
 * ADS empty state — one message, optional action.
 */
const AdsEmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className = '',
}) => (
  <div className={['ads-empty', className].filter(Boolean).join(' ')} role="status">
    {Icon ? (
      <div className="ads-empty__icon" aria-hidden>
        <Icon size={28} strokeWidth={1.5} />
      </div>
    ) : null}
    {title ? <p className="ads-empty__title">{title}</p> : null}
    {description ? <p className="ads-empty__description">{description}</p> : null}
    {action ? <div className="ads-empty__action">{action}</div> : null}
  </div>
);

export default AdsEmptyState;
